import React from "react";
import styles from "./FeatureDetailList.module.scss";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";

const FeatureDetailList = (props) => {
    const { list, data, columns = 3 } = props;
    
    let listToRender = data?.[0]?.list ?? list;
    const colClass = `col-md-${12 / columns}`;
    
    return (
        <div className={`${styles.FeatureDetailList}`}>
            {listToRender?.title && (
                <div className="d-flex align-items-center mb-4">
                    <h4 className="feature-title contrast">{listToRender.title}</h4>
                </div>
            )}
            
            <div className="row">
                {listToRender?.items && listToRender.items.map((item, index) => (
                    item.value && (
                        <div key={index} className={colClass}>
                            <div className="border-top py-3 d-flex align-items-center">
                                <div className="feature-icon contrast">
                                    {item.icon && <DynamicFontAwesomeIcon iconName={item.icon} size="2x" className="me-3" />}
                                </div>
                                <div>
                                    {item.title && (
                                        <h4 className="media-heading fw-bold contrast">
                                            {item.title}
                                        </h4>
                                    )}
                                    {item.value && (
                                        <div className="event-description contrast" dangerouslySetInnerHTML={{ __html: item.value }}></div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default FeatureDetailList;
